<template>
  <svg
    data-v-a8a9bb92=""
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M13.4043 0.0784381C13.3433 0.0690631 13.2742 0.0749225 13.1992 0.0999225C12.1992 0.299923 11.1004 0.899923 10.4004 1.59992C9.80037 2.19992 9.30076 3.19992 9.30076 4.09992C9.30076 4.29992 9.4992 4.50031 9.6992 4.50031C10.7992 4.40031 11.8996 3.79992 12.5996 3.09992C13.1996 2.29992 13.6992 1.40031 13.6992 0.500313C13.6992 0.275313 13.5871 0.106563 13.4043 0.0784381ZM13.6992 4.4007C11.8992 4.4007 11.1004 5.50031 9.90037 5.50031C8.60037 5.50031 7.40037 4.50031 5.90037 4.50031C3.80037 4.50031 0.599591 6.49992 0.599591 11.0999C0.499591 15.2999 4.29998 20.0003 6.49998 20.0003C7.79998 20.0003 8.10037 19.1995 9.90037 19.1995C11.7004 19.1995 12.1004 20.0003 13.4004 20.0003C14.9004 20.0003 16.0004 18.3999 16.9004 17.0999C17.3004 16.3999 17.6004 16.0007 17.9004 15.4007C18.1004 15.0007 17.9 14.6007 17.5 14.4007C14.9 13.1007 14.4008 8.9007 17.3008 7.4007C17.8008 7.1007 17.9 6.49953 17.5 6.19953C16.4 5.19953 14.7992 4.4007 13.6992 4.4007Z"></path>
  </svg>
</template>
